import { render, staticRenderFns } from "./DuplicateTracker.vue?vue&type=template&id=565df202&scoped=true&"
import script from "./DuplicateTracker.vue?vue&type=script&lang=js&"
export * from "./DuplicateTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565df202",
  null
  
)

export default component.exports